<template>
  <div
    v-if="displayInfo.cardTitle"
    class="big-card-box"
    @click="clickCard"
  >
    <img
      use-touch-event
      class="img"
      :src="displayInfo.cardImg"
    >
    <div class="product-info-box">
      <img
        class="close-big-card"
        src="https://qzonestyle.gtimg.cn/qzone/qzact/act/external/weishi/commercial/H5/close.png"
        @click="close"
      >
      <div class="product-title">
        {{ displayInfo.cardTitle }}
      </div>
      <div class="product-tag">
        <div
          v-if="labelList.length"
          class="recommend-box"
        >
          <template v-for="(item) in labelList">
            <div
              v-if="item"
              :key="item"
              class="recommend"
            >
              {{ item }}
            </div>
          </template>
          <p
            v-if="goodsInfo.sales"
            class="sale-num"
          >
            已售出{{ getSaleNum(Number(goodsInfo.sales)) }}件
          </p>
        </div>
      </div>
      <div class="price">
        <div class="price-num">
          ￥{{ formatPrice(goodsInfo.price) }}
        </div>
        <div class="buy">
          {{ displayInfo.cardButtonTxt }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ModelGoodsDisplayInfo, ModelGoodsInfo } from '@/types/model';

const enum EEmitEvent {
  close = 'close',
  onClickCard = 'on-click-card',
}

export default defineComponent({
  props: {
    displayInfo: {
      type: Object as PropType<ModelGoodsDisplayInfo>,
      default: () => ({}),
    },
    goodsInfo: {
      type: Object as PropType<ModelGoodsInfo>,
      default: () => ({}),
    },
  },
  emits: [EEmitEvent.close, EEmitEvent.onClickCard],
  data() {
    return {
      appId: '',
      path: '',
      labelList: [] as string[],
    };
  },
  mounted() {
    this.getLabel();
  },
  methods: {
    getSaleNum(num: number) {
      return num >= 10000 ? `${(num / 10000).toFixed(1)}万` : String(num);
    },
    formatPrice(price: number) {
      const p = Number(price) / 100;
      return Math.floor(p) ? p : p.toFixed(2);
    },
    getLabel() {
      if (!Object.keys(this.goodsInfo).length) {
        return;
      }
      const { tags, sales } = this.goodsInfo;
      if (tags.length && !!sales) {
        this.labelList = tags.slice(0, 1);
        this.labelList[0] = tags[0].length > 6 ? `${tags[0]?.slice(0, 6)}…` : tags[0];
      } else if (tags.length > 1 && !sales) {
        this.labelList[0] = tags[0].length > 6 ? `${tags[0]?.slice(0, 6)}…` : tags[0];
        this.labelList[1] = tags[1].length > 6 ? `${tags[1]?.slice(0, 6)}…` : tags[1];
      } else if (tags.length === 1 && !sales) {
        this.labelList = tags.slice(0, 1);
      }
    },
    // 关闭大卡
    close(e: Event) {
      e.stopPropagation();
      this.$emit(EEmitEvent.close);
    },
    clickCard() {
      this.$emit(EEmitEvent.onClickCard);
    },
  },
});
</script>

<style lang="scss">
.big-card-box {
  display: flex;
  @include responsiveStyleSingle(width, 77.8667, 'vw');
  @include responsiveStyleSingle(height, 24.5333, 'vw');
  animation: move 0.3s;
  position: relative;
  z-index: 10;
  background: rgba(0, 0, 0, 0.5);
  border-color: rgba(255, 255, 255, 0.15);
  border-style: solid;
  @include responsiveStyleSingle(border-width, 0.1333,'vw');
  @include responsiveStyleSingle(border-radius, 1.3333, 'vw');
  @include responsiveStyleSingle(margin-bottom, 3.2,'vw');
}
.big-card-box .img {
  @include responsiveStyleSingle(margin, 1.3333, 'vw');
  @include responsiveStyleSingle(height, 21.8667, 'vw');
  @include responsiveStyleSingle(width, 21.8667, 'vw');
  flex: none;
  @include responsiveStyleSingle(border-radius, 1.3333, 'vw');
  overflow: hidden;
  border: none;
}
.big-card-box .product-info-box {
  position: relative;
  @include responsiveStyleSingle(margin-left, 1.0667, 'vw');
  @include responsiveStyleSingle(width, 52.2667, 'vw');
}
.close-big-card {
  position: absolute;
  top: 0;
  right: 0;
  @include responsiveStyleSingle(width, 2.1333, 'vw');
  @include responsiveStyleSingle(height, 2.1333, 'vw');
  border-color: transparent;
  border-style: solid;
  @include responsiveStyleSingle(border-width, 1.6,'vw');
}
.product-title {
  @include responsiveStyleSingle(height, 5.3333, 'vw');
  @include responsiveStyleSingle(margin-top, 2.6667, 'vw');
  @include responsiveStyleSingle(font-size, 3.7333, 'vw');
  @include responsiveStyleSingle(line-height, 5.3333, 'vw');
  color: #fff;
  @include responsiveStyleSingle(max-width, 45.3333, 'vw');
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.product-tag {
  @include responsiveStyleSingle(margin-top, 0.5333, 'vw');
  @include responsiveStyleSingle(height, 4, 'vw');
  display: flex;
  align-items: center;
  @include responsiveStyleSingle(font-size, 2.9333, 'vw');
  color: #fff;
  opacity: 0.7;
}
.product-tag .tag-icon {
  @include responsiveStyleSingle(width, 2.4, 'vw');
  @include responsiveStyleSingle(height, 2.9333, 'vw');
  @include responsiveStyleSingle(margin-right, 0.5333, 'vw');
}
.product-tag .recommend-box {
  display: flex;
  align-items: center;
  @include responsiveStyleSingle(margin-right, 1.0667, 'vw');
  @include responsiveStyleSingle(height, 2.9333, 'vw');
  @include responsiveStyleSingle(line-height, 2.9333, 'vw');
}
.recommend-box .recommend {
  color: #fff;
  @include responsiveStyleSingle(margin-right, 2.4, 'vw');
  @include responsiveStyleSingle(height, 2.9333, 'vw');
  position: relative;
  &:after {
    position: absolute;
    display: block;
    content: "";
    @include responsiveStyleSingle(width, 0.2667, 'vw');
    @include responsiveStyleSingle(height, 2.9333, 'vw');
    background-color: #fff;
    @include responsiveStyleSingle(right, -1.3333, 'vw');
    top: 0;
  }
}
.recommend-box .recommend:last-child {
  &:after {
    background-color: transparent;
  }
}
.sale-num {
  color: rgba(255, 255, 255, 0.7);
}
.price {
  display: flex;
  align-items: center;
  @include responsiveStyleSingle(width, 49.8667, 'vw');
  @include responsiveStyleSingle(height, 6.4, 'vw');
  @include responsiveStyleSingle(margin-top, 2.9333, 'vw');
  @include responsiveStyleSingle(font-size, 3.7333, 'vw');
  color: #ffdc00;
}
.price .price-num {
  flex: auto;
}
.price .buy {
  flex: none;
  @include responsiveStyleSingle(height, 6.4, 'vw');
  text-align: center;
  @include responsiveStyleSingle(line-height, 6.4, 'vw');
  background: #7a46ff;
  @include responsiveStyleSingle(border-radius, 3.2, 'vw');
  padding: 0 15px;
  color: #fff;
}

@keyframes move {
  0% {
    @include responsiveTransform(0, 53.3333, 0, 'vw');
  }
  100% {
    transform: translateY(0);
  }
}
</style>
